<template>
  <div class="promoter-list" ref="container">
    <div class="header">
      <div class="promoterHeader bg-color-red">
        <div class="headerCon acea-row row-between-wrapper">
          <div>
            <div class="name">推广人数</div>
            <div>
              <span class="num">{{ user1List.length + user2List.length }}</span
              >人
            </div>
          </div>
          <div class="iconfont icon-tuandui"></div>
        </div>
      </div>
      <div class="nav acea-row row-around">
        <div
          class="item"
          :class="screen.param.grade == 0 ? 'on' : ''"
          @click="checkGrade(0)"
        >
          一级({{ user1List.length || 0 }})
        </div>
        <div
          class="item"
          :class="screen.param.grade == 1 ? 'on' : ''"
          @click="checkGrade(1)"
        >
          二级({{ user2List.length || 0 }})
        </div>
      </div>
    </div>
    <div class="list" v-if="spreadList.length > 0">
      <div :class="fixedState === true ? 'sortList' : ''">
        <div
          class="item acea-row row-between-wrapper"
          v-for="(val, index) in spreadList"
          :key="index"
        >
          <div class="picTxt acea-row row-between-wrapper">
            <div class="pictrue"><img :src="val.picture" /></div>
            <div class="text">
              <div class="name line1">{{ val.nickname }}</div>
              <div>加入时间: {{ fromatDate(val.created) }}</div>
            </div>
          </div>
          <div class="right">
            <div>
              <span
                :class="
                  val.payCount === 0 ? 'font-color-red' : 'font-color-gre'
                "
                >{{ val.payCount === 0 ? "未购买" : "已购买" }}</span
              >
            </div>
            <div>{{ val.payCount || 0 }} 单</div>
            <div>{{ val.totalCommission || 0 }} 元</div>
          </div>
        </div>
      </div>
    </div>
    <empty v-else description="您还没有推广人~"></empty>
  </div>
</template>
<script>
import { getSpreadUser } from "@/api/activity";
import { Empty, Toast } from "vant";
import dayjs from "dayjs";
export default {
  name: "PromoterList",
  components: {
    Empty,
  },
  props: {},
  data: function () {
    return {
      fixedState: false,
      id: this.$route.params.id,
      screen: {
        pageNO: 1,
        pageSize: 15,
        param: {
          grade: 0,
          keyword: "",
          sort: "",
          first: "",
          second: "",
        },
      },
      earnings: 2,
      totalCommission: 2,
      orderSum: 2,
      loaded: false,
      loading: false,
      spreadList: [],
      user1List: [],
      user2List: [],
      loadTitle: "",
    };
  },
  mounted: function () {
    this.getSpreadUsers();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getSpreadUsers();
    });
  },
  methods: {
    handleScroll: function () {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var offsetTop = document.querySelector(".header").clientHeight;
      if (scrollTop >= offsetTop) {
        this.fixedState = true;
      } else {
        this.fixedState = false;
      }
    },
    fromatDate(time) {
      return dayjs.unix(time).format("YYYY-MM-DD HH:mm");
    },
    getSpreadUsers: function () {
      let that = this;
      that.loading = true;
      let query = {
        pageNO: that.screen.pageNO,
        param: { grade: that.screen.param.grade },
      };
      getSpreadUser(that.id, query).then(
        (res) => {
          that.loading = false;
          that.user1List = res.result.list1 || [];
          that.user2List = res.result.list2 || [];

          this.spreadList = this.user1List || [];
          // that.spreadList.push.apply(that.spreadList, res.result.records);
          // that.loaded = res.result.records.length < that.screen.pageSize; //判断所有数据是否加载完成；
          // that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          // that.screen.pageNO = that.screen.pageNO + 1;
        },
        (error) => {
          Toast(error.msg);
        },
        300
      );
    },
    checkGrade: function (val) {
      this.screen.pageNO = 1;
      this.screen.param.grade = val;
      this.loading = false;
      this.loaded = false;

      if (val) {
        this.spreadList = this.user2List || [];
      } else {
        this.spreadList = this.user1List || [];
      }
    },
  },
};
</script>
